import { Paper } from "@material-ui/core";
import NoteList from "features/notes/NoteList";
import { NoteEntityTypes } from "features/notes/notesConsts";
import Authorize from "../../../components/Authorize";
import { permissionProfiles } from "../../../components/Authorize/permissionProfiles";
import { vehicleDetailsPageStyle } from "./VehicleDetailsPageStyle";

export const VehicleNotes = ({ vehicleDetails }) => {
    const classes = vehicleDetailsPageStyle();
    return (
        <>
            <Authorize profile={permissionProfiles.NOTES.VIEW_NOTES}>
                <Paper className={classes.card}>
                    <NoteList entityId={vehicleDetails?.id} entityType={NoteEntityTypes.VEHICLE} />
                </Paper>
            </Authorize>
        </>

    )
}